import FeaturesMegaMenu from 'src/organisms/Shared/2025_Q1/Header/ExpandableLinkMenu/FeaturesMegaMenu/FeaturesMegaMenu';
import FeaturesMegaMenuSideBar from 'src/organisms/Shared/2025_Q1/Header/ExpandableLinkMenu/FeaturesMegaMenu/FeaturesMegaMenuSideBar';
import ResourcesMegaMenu from 'src/organisms/Shared/2025_Q1/Header/ExpandableLinkMenu/ResourcesMegaMenu/ResourcesMegaMenu';
import ResourcesMegaMenuSideBar from 'src/organisms/Shared/2025_Q1/Header/ExpandableLinkMenu/ResourcesMegaMenu/ResourcesMegaMenuSideBar';

export interface ExpandableMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export interface IMenuLink {
  text: string;
  href: string;
  trackingSlug?: string;
  // Optional Mega Menu options
  useExpandableMenu?: boolean;
  expandableMenu?: (props: ExpandableMenuProps) => JSX.Element;
}

export type HeaderLinkSet = 'standard' | 'pro';
type HeaderLinkSubSet = 'top_menu' | 'side_menu';

// Desktop TopBar Links
const MENU_LINKS: IMenuLink[] = [
  {
    text: 'Features',
    href: '/features',
    trackingSlug: 'all_features',
    useExpandableMenu: true,
    expandableMenu: FeaturesMegaMenu,
  },
  { text: 'Branded Apps', href: '/pro', trackingSlug: 'mighty_pro' },
  { text: 'Services', href: '/pro/services', trackingSlug: 'mighty_pro' },
  {
    text: 'Resources',
    href: '/resources',
    trackingSlug: 'resources',
    useExpandableMenu: true,
    expandableMenu: ResourcesMegaMenu,
  },
  { text: 'Pricing', href: '/pricing', trackingSlug: 'pricing' },
];

const PRO_MENU_LINKS: IMenuLink[] = [
  { text: 'Case Studies', href: '/case-studies' },
  { text: 'Reviews', href: '/reviews', trackingSlug: 'reviews' },
];

const SIDE_BAR_FEATURES_LINK: IMenuLink = {
  text: 'Features',
  href: '/features',
  trackingSlug: 'all_features',
  useExpandableMenu: true,
  expandableMenu: FeaturesMegaMenuSideBar,
};

const SIDE_BAR_RESOURCES_LINK: IMenuLink = {
  text: 'Resources',
  href: '/resources',
  trackingSlug: 'resources',
  useExpandableMenu: true,
  expandableMenu: ResourcesMegaMenuSideBar,
};

// Mobile SideMenu Links
const SIDE_BAR_LINKS = [
  SIDE_BAR_FEATURES_LINK,
  { text: 'Branded Apps', href: '/pro', trackingSlug: 'mighty_pro' },
  { text: 'Services', href: '/pro/services', trackingSlug: 'mighty_pro' },
  SIDE_BAR_RESOURCES_LINK,
  { text: 'Pricing', href: '/pricing', trackingSlug: 'pricing' },
];
const PRO_SIDE_BAR_LINKS = [{ text: 'Mighty Networks', href: '/' }, ...PRO_MENU_LINKS];

export const createHeaderLinks = (set: HeaderLinkSet, subset: HeaderLinkSubSet): IMenuLink[] => {
  switch (set) {
    case 'standard':
      switch (subset) {
        case 'top_menu':
          return MENU_LINKS;
        case 'side_menu':
          return SIDE_BAR_LINKS;
        default:
          return [];
      }
    case 'pro':
      switch (subset) {
        case 'top_menu':
          return PRO_MENU_LINKS;
        case 'side_menu':
          return PRO_SIDE_BAR_LINKS;
        default:
          return [];
      }
    default:
      return [];
  }
};
